import { FC } from "react"
import { BirdEyeReview, Reviews } from "../../../types"
import ImgBirdEyeLogo from "../../../assets/icons/birdeye_logo.png"
import ImgStar from "../../../assets/icons/star.svg"
import If from "../if"

interface Props {
  reviews?: Reviews
}

const BirdEyeReviewsList: FC<Props> = ({ reviews }) => {
  return (
    <div className="pb-6">
      <div className="text-lg font-bold">BirdEye reviews</div>

      <div className="py-4 flex items-center">
        <div className="pr-3">
          <img src={ImgBirdEyeLogo} alt="BirdEye Logo" className="h-8" />
        </div>
      </div>

      <If
        condition={!!reviews?.reviews?.length}
        then={reviews?.reviews.map(review => {
          const birdEyeReview = review as BirdEyeReview
          const reviewerName = [
            birdEyeReview.reviewer?.firstName,
            birdEyeReview.reviewer?.lastName
          ]
            .filter(Boolean)
            .join(" ")
          return (
            <div key={birdEyeReview.reviewId} className="py-4">
              <div className="flex items-center leading-5">
                <div className="w-5 h-5">
                  <img className="h-full" src={ImgStar} alt="Star" />
                </div>
                <div className="font-bold pl-2">{birdEyeReview.rating}</div>
                <div className="text-neutral-300">
                  <span className="pl-3 pr-2">.</span>
                  {reviewerName}
                </div>
              </div>
              <div className="pt-4">{birdEyeReview.comments}</div>
            </div>
          )
        })}
        else={<div className="py-4">-</div>}
      />
    </div>
  )
}

export default BirdEyeReviewsList
